/**
 * Mixer — many-to-one junction.
 * Mass conservation, mass-weighted enthalpy mixing, min(P).
 */
import type { NSComponent, Junction, ComponentUpdate } from '../types';

export class NSMixer implements NSComponent {
  id: string;
  type = 'mixer';
  params: Record<string, any>;

  constructor(id: string) {
    this.id = id;
    this.params = {};
  }

  applyBoundaryConditions(inlet: Junction, _outlet: Junction, _dt: number): ComponentUpdate {
    // Mixing is handled by the junction equations, NOT by a component delta:
    // nsNetwork Step 3 sets the junction enthalpy to the inflow-mass-weighted
    // mix, and Step 4 (R2-B3) republishes it onto every outflow cell even though
    // deltaH === 0 here — so the mixed enthalpy advects downstream (an
    // isenthalpic pass-through with respect to the ALREADY-mixed inlet state).
    return {
      deltaP: 0,
      deltaH: 0,
      momentumSource: 0,
      energySource: 0,
      metadata: {},
    };
  }
}
